// src/components/Confirmation.js
import React, { useEffect, useState, useRef, useContext } from "react";
import PrintButton from "./printbutton";
import PdfButton from "./pdfbutton";
import EmailToast from "./email";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
//import "bootstrap/dist/css/bootstrap.min.css";
import { useLocation } from "react-router-dom";
import Footer from "../Footer";
import BackToTopButton from "../BackToTop";
//import "./conformpage.css";
import { CarrierContext } from "../../contexts/CarrierContext";
import { LanguageContext } from "../../contexts/LanguageContext";
import HeaderPayment from "../HeaderPayment";
import Breadcrumbs from "../Breadcrumbs";
import { decryptData } from "../../utils/cryptoEncrypt";
import { dompurifyHtml } from "../../utils/sanitizeInput";

const Confirmation = () => {
  const location = useLocation();
  // Extract the encrypted string from the URL (location.search includes '?')
  const encryptedData = location.search.slice(1); // remove '?'
  // Decrypt the encrypted data
  const decryptedData = decryptData(encryptedData);
  // Step 3: Parse it as a query string
  const queryParams = new URLSearchParams(decryptedData);
  // Step 4: Access individual values
  const confirmCim = queryParams.get("cim");
  const name = queryParams.get("name");
  const confirmationNo = queryParams.get("confirmation_no");
  const scheduledDate = queryParams.get("scheduled_date");
  const amount = queryParams.get("amount");
  const paymentTypeFlag = queryParams.get("payment_type");
  const accountLastFour = queryParams.get("lastfour");
  const payment_method = queryParams.get("payment_method");
  const payment_type = queryParams.get("payment_type");
  const onetime_binder = queryParams.get("onetime_binder");
  const mainConfirmationContentsReff = useRef(null);
  const [nachaHtmlContent, setNachaHtmlContent] = useState("");
  const carrierContxt = useContext(CarrierContext);
  const urlCarrier = carrierContxt.hasOwnProperty("carrier")
    ? carrierContxt.carrier
    : null;

  const { cmsAllPages, handleLanguage, langErr } = useContext(LanguageContext);
  const [cms, setConfirmationCMS] = useState("");

  const [isNachaContentVisible, setNachaContentVisible] = useState(false);
  const [langSelected, setLangSelected] = useState(
    () => sessionStorage.getItem("langSel") || "eng"
  ); // default language
  // Check if current carrier is excluded for carousel
  const carouselExcludedCarriers = (
      process.env.REACT_APP_CAROUSEL_EXCLUDED_CARRIERS || ""
  )
      .split(",")
      .map((c) => c.trim().toLowerCase());

  const isCarouselExcluded = carouselExcludedCarriers.includes(
      urlCarrier?.toLowerCase()
  );

  //pmo0002954 - show confirmation date for bcbs start - as54326 
  
  const confirmationDateExcludedCarriers = (
    process.env.REACT_APP_SHOW_CONFIRMATION_DATE || ""
)
    .split(",")
    .map((c) => c.trim().toLowerCase());

const isConfirmationDateExcluded = confirmationDateExcludedCarriers.includes(
    urlCarrier?.toLowerCase()
);

//pmo0002954 - show confirmation date for bcbs end - as54326

  // Handler function to toggle the visibility of the content
  const showNachaContent = () => {
    setNachaContentVisible(true);
  };
  const nachaContentRef = useRef(null); // Ref for the nacha content container
  useEffect(() => {
    // Get the HTML content from sessionStorage
    const content = sessionStorage.getItem("nacha_" + urlCarrier);
    if (content) {
      setNachaHtmlContent(content);
    }
  }, [urlCarrier]);
  // const { confirmImg, type } = location.state || {};
  // const [data, setData] = useState(null);
  // const componentRef = useRef();

  useEffect(() => {
    if (cmsAllPages && cmsAllPages.confirm) {
      setConfirmationCMS(cmsAllPages.confirm);
    }
  }, [cmsAllPages, setConfirmationCMS]);

  useEffect(() => {
    const timer = setTimeout(() => {
      if (mainConfirmationContentsReff.current) {
        mainConfirmationContentsReff.current.focus();
      }
    }, 1000); // Delay to ensure the DOM is fully rendered

    return () => clearTimeout(timer); // Cleanup the timer
  }, []);

  useEffect(() => {
    if (isNachaContentVisible && nachaContentRef.current) {
      nachaContentRef.current.focus(); // Step 2: Focus the div when visible
    }
  }, [isNachaContentVisible]);
  const formatDate = (date) => {
    const month = String(date.getUTCMonth() + 1).padStart(2, "0"); // Month is 0-indexed, so add 1
    const day = String(date.getUTCDate()).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${month}/${day}/${year}`;
  };
  const data = {
    cim: confirmCim || "",
    name: name || "",
    amount: amount || 0,
    date: formatDate(new Date(scheduledDate)) || "",
    confirmationCode: confirmationNo || "",
    paymentTypeFlag: paymentTypeFlag || "",
    payment_method: payment_method || "",
    payment_type: payment_type || "",
    onetime_binder: onetime_binder || "",
  };

  if (!data) {
    return <div>Loading...</div>;
  }
  const formatAmount = (value) => {
    if (value !== null && value !== undefined) {
      return new Intl.NumberFormat("en-US", {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      }).format(value);
    }
    return "0.00";
  };
  return (
    <>
      <div
          id="main-confirmation-contents"
          ref={mainConfirmationContentsReff}
          tabIndex="-1"
      >
        <div id={`header-${urlCarrier}`}>
          <HeaderPayment
            page="confirm"
            setLangSelected={setLangSelected}
          ></HeaderPayment>
        </div>
        <main id="main" className="main">
          <div>
            <Breadcrumbs cms={cms}></Breadcrumbs>
          </div>
          <div className="container-lg">
            {/* <!-- Demo header--> */}
            <section className="py-1 pb-5 bg-white  mt-4">
              <div className="py-4">
                <div className="content px-xl-4 px-2">
                  <div className="col-12 d-xl-flex d-md-flex d-sm-block">
                    <div className="col-xl-7 col-md-7 px-xl-2 px-sm-1 px-md-0 px-0">
                      <div className="col-12 mt-3 text-center text-xl-start text-sm-center text-md-start">
                        <div className="d-grid d-sm-flex col-12 mb-2 gap-2">
                          <PrintButton cms={cms} carrier={urlCarrier} />
                           <EmailToast
                            data={data}
                            cms={cms}
                            lastfour={accountLastFour}
                          />
                          <PdfButton data={data} cms={cms} carrier={urlCarrier} />
                        </div>
                      </div>

                      <div className="col-12 payment mb-3" tabIndex="0">
                        <h4
                          className={`heading4-${urlCarrier} fw-semibold mt-4`}
                        >
                          {" "}
                          {cms.label_success_confirmation}{" "}
                          {cms.label_success_confirmation_message}
                          <span className="confirm"> {confirmationNo}</span>
                        </h4>
                        <p>
                          {onetime_binder === "BINDER" &&
                            cms.label_success_confirmation_binder_payment_details}
                          {onetime_binder === "ONETIME" &&
                            cms.label_success_confirmation_onetime_payment_details}
                        </p>
                      </div>

                      <div className="payment mb-3 small-lbl" tabIndex="0">
                        <h4
                          className="confirm fw-semibold mt-4"
                        >
                          {" "}
                          {cms.label_event_summary}
                        </h4>
                        <div className="col-12 mt-4">
                          <div className="row g-3">
                            <div className="col-12 col-sm-6">
                              <img
                                className="me-2 user-image"
                                src={
                                  urlCarrier === "bcbsaz"
                                    ? `${process.env.PUBLIC_URL}/images/icons/user-bcbsaz.svg`
                                    : `${process.env.PUBLIC_URL}/images/icons/user.svg`
                                }
                                alt="Name"
                              />
                              <label id="summary-name">
                                <b className="fw-semibold">
                                  {cms.label_confirmation_name}
                                </b>{" "}
                                {name}
                              </label>
                            </div>
                            <div className="col-12 col-sm-6">
                              <img
                                className="me-2 user-image"
                                src={
                                  urlCarrier === "bcbsaz"
                                    ? `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign-bcbsaz.svg`
                                    : `${process.env.PUBLIC_URL}/images/icons/Payment/dollar-sign.svg`
                                }
                                alt="Payment"
                              />
                              <label id="summary-amount">
                                <b className="fw-semibold">
                                  {cms.label_confirmation_payment_amount}
                                </b>{" "}
                                ${formatAmount(amount)}
                              </label>
                            </div>
                          </div>
                          {isConfirmationDateExcluded && (
                          <div className="col-12 mt-4">
                            <img
                              className="me-2"
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                              }
                              alt="Authorization Date"
                            />
                            <label id="summary-printed-on">
                              <b className="fw-semibold">
                                {cms.label_confirmation_authorization_date}
                              </b>{" "}
                              {formatDate(new Date())}
                            </label>
                          </div>
                          )}
                          <div className="col-12 mt-4">
                            <img
                              className="me-2"
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                              }
                              alt="Calendar"
                            />
                            <label id="summary-sch-date">
                              <b className="fw-semibold">
                                {cms.label_confirmation_scheduled_for}
                              </b>{" "}
                              {formatDate(new Date(scheduledDate))}
                            </label>
                          </div>
                          
                          
                          {isConfirmationDateExcluded && (
                          <div className="col-12 mt-4 show-in-print">
                            <img
                              className="me-2"
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                              }
                              alt="Printed On"
                            />
                            <label id="summary-printed-on">
                              <b className="fw-semibold">
                                {cms.label_confirmation_printed_on}
                              </b>{" "}
                              {formatDate(new Date())}
                            </label>
                          </div>
                          )}
                          {isConfirmationDateExcluded && (
                          <div className="col-12 mt-4 show-in-download">
                            <img
                              className="me-2"
                              src={
                                urlCarrier === "bcbsaz"
                                  ? `${process.env.PUBLIC_URL}/images/icons/calendar-bcbsaz.svg`
                                  : `${process.env.PUBLIC_URL}/images/icons/calendar.svg`
                              }
                              alt="Downloaded On"
                            />
                            <label id="summary-downloaded-on">
                              <b className="fw-semibold">
                                {cms.label_confirmation_downloaded_on}
                              </b>{" "}
                              {formatDate(new Date())}
                            </label>
                          </div>
                          )}
                          {isConfirmationDateExcluded && (
                          <div className="col-12 mt-4 show-in-print show-in-download">
                            <p className="fw-semibold" style={{ fontSize: "12px", width: "100%" }}>
                              <b>{cms.label_confirmation_disclaimer_title}</b>{" "}
                              {cms.label_confirmation_disclaimer}
                            </p>
                          </div>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-xl-5 col-md-5 mt-3 payment text-center text-xl-start text-sm-center text-md-start" tabIndex="0">
                      <h3
                        className={`fw-semibold mt-4 payment-confirmation-heading-${urlCarrier}`}
                      >
                        {cms.label_payment_confirmation}
                      </h3>
                      <p className="mt-1" style={{ fontSize: "12px" }}>
                        {cms.label_payment_confirmation_message}
                      </p>
                      <img
                        src={`${process.env.PUBLIC_URL}/images/illustrations/confirmation-${urlCarrier}.svg`}
                        className="w-90"
                        alt="Payment-Confirmation"
                      />
                    </div>
                  </div>

                  {/*  <div className="toast">
                    <div className="toast-content">
                      <div className="col-12 px-3">
                        <form>
                          <div className="form-floating mb-2 border-bottom">
                            <input
                              type="text"
                              className="form-control"
                              id="validationServer01"
                              placeholder="Name@example.com"
                              required=""
                              style={{ background: "transparent" }}
                            />
                            <label
                              htmlFor="validationServer01"
                              className="form-label"
                            >
                              <img
                                src={`${process.env.PUBLIC_URL}/images/icons/mail.svg`}
                                className="me-2"
                                width="17"
                                height="17"
                                alt="Email"
                              />
                              {cms.required_mail_id}{" "}
                              <span className="text-danger">*</span>
                            </label>
                          </div>
                          <div className="d-grid mt-4 mb-2">
                            <input
                              type="submit"
                              className="btn btn-primary btn-lg"
                              value={cms.label_send}
                            />
                          </div>
                        </form>
                      </div>
                    </div>
                    <i className="fe fe-x close"></i>

                    <div className="progress"></div>
                  </div>*/}

                  <div className="col-12 mt-4 payment">
                    <div className="col-xl-7 col-md-12 px-xl-2 px-sm-1 px-md-0 px-0">
                      <div
                        className="show-in-download nacha-content-container"
                        dangerouslySetInnerHTML={{
                          __html: dompurifyHtml(nachaHtmlContent),
                        }} // Render HTML content
                      />
                      <div
                        className="show-in-print nacha-content-container"
                        dangerouslySetInnerHTML={{
                          __html: dompurifyHtml(nachaHtmlContent),
                        }} // Render HTML content
                      />
                      {!isNachaContentVisible && (
                        <button
                          className={urlCarrier === "bcbsaz" ? "btn btn-outline-secondary btn-lg exclude-in-print fw-semibold" : "auth_content_link exclude-in-print fw-semibold"}
                          onClick={showNachaContent}
                        >
                          {cms?.label_authorization_content}
                        </button>
                      )}

                      {/* Show content when isContentVisible is true */}
                      {isNachaContentVisible && (
                        <div
                          className="exclude-in-print"
                          ref={nachaContentRef} // Attach the ref
                          tabIndex="0" // Make the div focusable
                          dangerouslySetInnerHTML={{
                            __html: dompurifyHtml(nachaHtmlContent),
                          }} // Render HTML content
                        />
                      )}

                      <ToastContainer></ToastContainer>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>

        <BackToTopButton></BackToTopButton>

        <Footer cms={cms}></Footer>
      </div>
    </>
  );
};

export default Confirmation;
